import { useApi } from './useApi';
import { useLoader } from '../context/loaders/useLoader';
import { useToast } from '../context/toasts/useToast';

export function useLabelMutations(boardId: number, onUpdate: () => void) {
  const { createLabel } = useApi();
  const { withLoader } = useLoader();
  const { addNotification } = useToast();

  const addLabel = async (name: string, color: string) => {
    try {
      await withLoader(() => createLabel(boardId, { name, color }), 'Creating label...');
      onUpdate();
      addNotification({
        type: 'success',
        title: 'Label Created',
        message: 'Label has been created successfully.',
        duration: 3000,
      });
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to create label';
      addNotification({
        type: 'error',
        title: 'Error',
        message: errorMessage,
        duration: 5000,
      });
      return false;
    }
  };

  return {
    addLabel,
  };
}

export function useCardLabelMutations(cardId: number, onUpdate: () => void) {
  const { addLabelToCard, removeLabelFromCard } = useApi();
  const { withLoader } = useLoader();
  const { addNotification } = useToast();

  const addLabelToCardMutation = async (labelId: number) => {
    try {
      await withLoader(() => addLabelToCard(cardId, labelId), 'Adding label...');
      onUpdate();
      addNotification({
        type: 'success',
        title: 'Label Added',
        message: 'Label has been added to the card.',
        duration: 3000,
      });
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to add label';
      addNotification({
        type: 'error',
        title: 'Error',
        message: errorMessage,
        duration: 5000,
      });
      return false;
    }
  };

  const removeLabelFromCardMutation = async (labelId: number) => {
    try {
      await withLoader(() => removeLabelFromCard(cardId, labelId), 'Removing label...');
      onUpdate();
      addNotification({
        type: 'success',
        title: 'Label Removed',
        message: 'Label has been removed from the card.',
        duration: 3000,
      });
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Failed to remove label';
      addNotification({
        type: 'error',
        title: 'Error',
        message: errorMessage,
        duration: 5000,
      });
      return false;
    }
  };

  return {
    addLabelToCardMutation,
    removeLabelFromCardMutation,
  };
}
